import React from 'react';

const SvgLv = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="LV_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="LV_svg__b" fill="#fff">
        <use xlinkHref="#LV_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        fill="#B9414B"
        mask="url(#LV_svg__b)"
        d="M0 0h28v8H0zM0 12h28v8H0z"
      />
    </g>
  </svg>
);

export default SvgLv;
